<template>
  <svg
    v-if="size === 'large'"
    width="217"
    height="40"
    viewBox="0 0 217 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0921 2.02483C20.2992 1.3875 21.2008 1.3875 21.4079 2.02483L25.085 13.3417C25.1776 13.6267 25.4432 13.8197 25.7429 13.8197H37.6421C38.3122 13.8197 38.5909 14.6772 38.0487 15.0711L28.422 22.0653C28.1796 22.2414 28.0781 22.5537 28.1707 22.8387L31.8478 34.1555C32.0549 34.7928 31.3254 35.3228 30.7833 34.9289L21.1566 27.9347C20.9142 27.7586 20.5858 27.7586 20.3434 27.9347L10.7167 34.9289C10.1746 35.3228 9.44512 34.7928 9.6522 34.1555L13.3293 22.8387C13.4219 22.5537 13.3204 22.2414 13.078 22.0653L3.45129 15.0711C2.90915 14.6772 3.18777 13.8197 3.8579 13.8197H15.7571C16.0568 13.8197 16.3224 13.6267 16.415 13.3417L20.0921 2.02483Z"
      :fill="fill"
    />
    <path
      d="M64.0921 2.02483C64.2992 1.3875 65.2008 1.3875 65.4079 2.02483L69.085 13.3417C69.1776 13.6267 69.4432 13.8197 69.7429 13.8197H81.6421C82.3122 13.8197 82.5909 14.6772 82.0487 15.0711L72.422 22.0653C72.1796 22.2414 72.0781 22.5537 72.1707 22.8387L75.8478 34.1555C76.0549 34.7928 75.3254 35.3228 74.7833 34.9289L65.1566 27.9347C64.9142 27.7586 64.5858 27.7586 64.3434 27.9347L54.7167 34.9289C54.1746 35.3228 53.4451 34.7928 53.6522 34.1555L57.3293 22.8387C57.4219 22.5537 57.3204 22.2414 57.078 22.0653L47.4513 15.0711C46.9091 14.6772 47.1878 13.8197 47.8579 13.8197H59.7571C60.0568 13.8197 60.3224 13.6267 60.415 13.3417L64.0921 2.02483Z"
      :fill="fill"
    />
    <path
      d="M108.092 2.02483C108.299 1.3875 109.201 1.3875 109.408 2.02483L113.085 13.3417C113.178 13.6267 113.443 13.8197 113.743 13.8197H125.642C126.312 13.8197 126.591 14.6772 126.049 15.0711L116.422 22.0653C116.18 22.2414 116.078 22.5537 116.171 22.8387L119.848 34.1555C120.055 34.7928 119.325 35.3228 118.783 34.9289L109.157 27.9347C108.914 27.7586 108.586 27.7586 108.343 27.9347L98.7167 34.9289C98.1746 35.3228 97.4451 34.7928 97.6522 34.1555L101.329 22.8387C101.422 22.5537 101.32 22.2414 101.078 22.0653L91.4513 15.0711C90.9091 14.6772 91.1878 13.8197 91.8579 13.8197H103.757C104.057 13.8197 104.322 13.6267 104.415 13.3417L108.092 2.02483Z"
      :fill="fill"
    />
    <path
      d="M152.33 2.10254C152.462 1.69554 153.038 1.69554 153.17 2.10254L156.848 13.4189C156.974 13.8069 157.335 14.0693 157.743 14.0693H169.643C170.07 14.0697 170.247 14.6177 169.901 14.8691L160.275 21.8633C159.945 22.1031 159.807 22.528 159.933 22.916L163.61 34.2324C163.743 34.6393 163.277 34.9778 162.931 34.7266L153.304 27.7324C152.974 27.4926 152.526 27.4926 152.196 27.7324L142.569 34.7266C142.223 34.9778 141.757 34.6393 141.89 34.2324L145.567 22.916C145.693 22.528 145.555 22.1031 145.225 21.8633L135.599 14.8691C135.253 14.6177 135.43 14.0697 135.857 14.0693H147.757C148.165 14.0693 148.526 13.8069 148.652 13.4189L152.33 2.10254Z"
      :stroke="fill"
      stroke-width="0.5"
    />
    <mask
      id="mask0_10460_38787"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="135"
      y="1"
      width="36"
      height="35"
    >
      <path
        d="M152.092 2.02483C152.299 1.3875 153.201 1.3875 153.408 2.02483L157.085 13.3417C157.178 13.6267 157.443 13.8197 157.743 13.8197H169.642C170.312 13.8197 170.591 14.6772 170.049 15.0711L160.422 22.0653C160.18 22.2414 160.078 22.5537 160.171 22.8387L163.848 34.1555C164.055 34.7928 163.325 35.3228 162.783 34.9289L153.157 27.9347C152.914 27.7586 152.586 27.7586 152.343 27.9347L142.717 34.9289C142.175 35.3228 141.445 34.7928 141.652 34.1555L145.329 22.8387C145.422 22.5537 145.32 22.2414 145.078 22.0653L135.451 15.0711C134.909 14.6772 135.188 13.8197 135.858 13.8197H147.757C148.057 13.8197 148.322 13.6267 148.415 13.3417L152.092 2.02483Z"
        :fill="fill"
      />
    </mask>
    <g mask="url(#mask0_10460_38787)">
      <rect
        x="128.706"
        y="-3.21289"
        width="24.093"
        height="43.3674"
        :fill="fill"
      />
    </g>
    <path
      d="M196.33 2.10254C196.462 1.69554 197.038 1.69554 197.17 2.10254L200.848 13.4189C200.974 13.8069 201.335 14.0693 201.743 14.0693H213.643C214.07 14.0697 214.247 14.6177 213.901 14.8691L204.275 21.8633C203.945 22.1031 203.807 22.528 203.933 22.916L207.61 34.2324C207.743 34.6393 207.277 34.9778 206.931 34.7266L197.304 27.7324C196.974 27.4926 196.526 27.4926 196.196 27.7324L186.569 34.7266C186.223 34.9778 185.757 34.6393 185.89 34.2324L189.567 22.916C189.693 22.528 189.555 22.1031 189.225 21.8633L179.599 14.8691C179.253 14.6177 179.43 14.0697 179.857 14.0693H191.757C192.165 14.0693 192.526 13.8069 192.652 13.4189L196.33 2.10254Z"
      :stroke="fill"
      stroke-width="0.5"
    />
  </svg>

  <svg
    v-else-if="size === 'base'"
    width="142"
    height="25"
    viewBox="0 0 142 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0921 2.02483C12.2992 1.3875 13.2008 1.3875 13.4079 2.02483L15.4011 8.15929C15.4937 8.44431 15.7593 8.63729 16.059 8.63729H22.5092C23.1793 8.63729 23.4579 9.49481 22.9158 9.8887L17.6975 13.68C17.455 13.8562 17.3536 14.1684 17.4462 14.4534L19.4394 20.5879C19.6465 21.2252 18.917 21.7552 18.3749 21.3613L13.1566 17.57C12.9142 17.3938 12.5858 17.3938 12.3434 17.57L7.12511 21.3613C6.58296 21.7552 5.85351 21.2252 6.06059 20.5879L8.0538 14.4534C8.14641 14.1684 8.04495 13.8562 7.8025 13.68L2.58421 9.8887C2.04207 9.49481 2.3207 8.63729 2.99082 8.63729H9.44098C9.74067 8.63729 10.0063 8.44431 10.0989 8.15929L12.0921 2.02483Z"
      :fill="fill"
    />
    <path
      d="M41.0921 2.02483C41.2992 1.3875 42.2008 1.3875 42.4079 2.02483L44.4011 8.15929C44.4937 8.44431 44.7593 8.63729 45.059 8.63729H51.5092C52.1793 8.63729 52.4579 9.49481 51.9158 9.8887L46.6975 13.68C46.455 13.8562 46.3536 14.1684 46.4462 14.4534L48.4394 20.5879C48.6465 21.2252 47.917 21.7552 47.3749 21.3613L42.1566 17.57C41.9142 17.3938 41.5858 17.3938 41.3434 17.57L36.1251 21.3613C35.583 21.7552 34.8535 21.2252 35.0606 20.5879L37.0538 14.4534C37.1464 14.1684 37.045 13.8562 36.8025 13.68L31.5842 9.8887C31.0421 9.49481 31.3207 8.63729 31.9908 8.63729H38.441C38.7407 8.63729 39.0063 8.44431 39.0989 8.15929L41.0921 2.02483Z"
      :fill="fill"
    />
    <path
      d="M70.0921 2.02483C70.2992 1.3875 71.2008 1.3875 71.4079 2.02483L73.4011 8.15929C73.4937 8.44431 73.7593 8.63729 74.059 8.63729H80.5092C81.1793 8.63729 81.4579 9.49481 80.9158 9.8887L75.6975 13.68C75.455 13.8562 75.3536 14.1684 75.4462 14.4534L77.4394 20.5879C77.6465 21.2252 76.917 21.7552 76.3749 21.3613L71.1566 17.57C70.9142 17.3938 70.5858 17.3938 70.3434 17.57L65.1251 21.3613C64.583 21.7552 63.8535 21.2252 64.0606 20.5879L66.0538 14.4534C66.1464 14.1684 66.045 13.8562 65.8025 13.68L60.5842 9.8887C60.0421 9.49481 60.3207 8.63729 60.9908 8.63729H67.441C67.7407 8.63729 68.0063 8.44431 68.0989 8.15929L70.0921 2.02483Z"
      :fill="fill"
    />
    <path
      d="M99.2021 2.06055C99.3747 1.52949 100.125 1.52949 100.298 2.06055L102.291 8.19531C102.399 8.52758 102.709 8.75275 103.059 8.75293H109.509C110.067 8.75293 110.299 9.46766 109.848 9.7959L104.63 13.5869C104.347 13.7924 104.229 14.1567 104.337 14.4893L106.33 20.623C106.503 21.1542 105.894 21.5958 105.442 21.2676L100.225 17.4766C99.9417 17.2711 99.5583 17.2711 99.2754 17.4766L94.0576 21.2676C93.6058 21.5958 92.9974 21.1542 93.1699 20.623L95.1631 14.4893C95.2711 14.1567 95.153 13.7924 94.8701 13.5869L89.6523 9.7959C89.2006 9.46766 89.4328 8.75293 89.9912 8.75293H96.4414C96.7908 8.75275 97.1009 8.52758 97.209 8.19531L99.2021 2.06055Z"
      :stroke="fill"
      stroke-width="0.230588"
    />
    <mask
      id="mask0_10460_38588"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="89"
      y="1"
      width="22"
      height="21"
    >
      <path
        d="M99.0921 2.02483C99.2992 1.3875 100.201 1.3875 100.408 2.02483L102.401 8.15929C102.494 8.44431 102.759 8.63729 103.059 8.63729H109.509C110.179 8.63729 110.458 9.49481 109.916 9.8887L104.698 13.68C104.455 13.8562 104.354 14.1684 104.446 14.4534L106.439 20.5879C106.646 21.2252 105.917 21.7552 105.375 21.3613L100.157 17.57C99.9142 17.3938 99.5858 17.3938 99.3434 17.57L94.1251 21.3613C93.583 21.7552 92.8535 21.2252 93.0606 20.5879L95.0538 14.4534C95.1464 14.1684 95.045 13.8562 94.8025 13.68L89.5842 9.8887C89.0421 9.49481 89.3207 8.63729 89.9908 8.63729H96.441C96.7407 8.63729 97.0063 8.44431 97.0989 8.15929L99.0921 2.02483Z"
        :fill="fill"
      />
    </mask>
    <g mask="url(#mask0_10460_38588)">
      <rect
        x="84.7227"
        y="-2.00781"
        width="15.0581"
        height="27.1046"
        :fill="fill"
      />
    </g>
    <path
      d="M128.202 2.06055C128.375 1.52949 129.125 1.52949 129.298 2.06055L131.291 8.19531C131.399 8.52758 131.709 8.75275 132.059 8.75293H138.509C139.067 8.75293 139.299 9.46766 138.848 9.7959L133.63 13.5869C133.347 13.7924 133.229 14.1567 133.337 14.4893L135.33 20.623C135.503 21.1542 134.894 21.5958 134.442 21.2676L129.225 17.4766C128.942 17.2711 128.558 17.2711 128.275 17.4766L123.058 21.2676C122.606 21.5958 121.997 21.1542 122.17 20.623L124.163 14.4893C124.271 14.1567 124.153 13.7924 123.87 13.5869L118.652 9.7959C118.201 9.46766 118.433 8.75293 118.991 8.75293H125.441C125.791 8.75275 126.101 8.52758 126.209 8.19531L128.202 2.06055Z"
      :stroke="fill"
      stroke-width="0.230588"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2AtomsBaseStarsThreeAndHalfStar'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  },
  size: {
    type: String,
    default: 'base',
    validator: value => ['base', 'large'].includes(value)
  }
})
</script>
